import { Selector, createSelector } from "reselect";
import { ChatWithShortInfo } from "@sms/shared/chat/chat.interface";

import { ApplicationStore } from "../application.store";

export const makeSelectChatInfoById: () => Selector<ApplicationStore, ChatWithShortInfo | undefined> = (): Selector<
  ApplicationStore,
  ChatWithShortInfo | undefined
> =>
  createSelector(
    [
      (state: ApplicationStore): ChatWithShortInfo[] => state.chats.chats,
      (state: ApplicationStore): ChatWithShortInfo[] => state.archive.chatsArchivedList,
      (_: ApplicationStore, chatId: string | null): string | null => chatId
    ],
    (chats, archiveChats, chatId) => {
      if (!chatId) {
        return undefined;
      }
      let activeChat: ChatWithShortInfo | undefined = chats.find(chat => chat.id === chatId);

      if (!activeChat) {
        activeChat = archiveChats.find(chat => chat.id === chatId);
      }

      return activeChat;
    }
  );
